import React, { useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import Footer from "../components/Footer";
import "../App.css";

const Apply = () => {
  const { link } = useParams();
  const form = useRef();
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resumeName, setResumeName] = useState("");

  const formattedPosition = link
    ? link.split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ")
    : "Maritime Specialist";

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus("Submitting your application...");

    // Using configured EmailJS keys
    emailjs
      .sendForm(
        "service_v7xwleq",
        "template_b9dzc2b",
        form.current,
        "nY-PyzSMsXXjQl2Id"
      )
      .then(
        () => {
          setStatus("Application sent successfully! Our HR superintendents will review your profile shortly.");
          form.current.reset();
          setResumeName("");
          setIsSubmitting(false);
        },
        (error) => {
          console.error("EmailJS Error:", error);
          setStatus("Direct submission encountered an error. Please email your CV directly to info@bluewavesshipmanagement.com.");
          setIsSubmitting(false);
        }
      );
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <div className="career-form-container" style={{ flex: 1, padding: "5rem 1.5rem" }}>
        <div style={{ maxWidth: "680px", margin: "0 auto" }}>
          <Link to="/career" style={{ color: "#f59e0b", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "0.5rem", marginBottom: "1.5rem", fontWeight: "600" }}>
            ← Back to All Openings
          </Link>
          
          <h2 style={{ fontSize: "2rem", fontWeight: "800", color: "#1a2b49", marginBottom: "0.5rem" }}>
            Apply for {formattedPosition}
          </h2>
          <p style={{ color: "#64748b", marginBottom: "2rem" }}>
            Join BlueWave Ship Management and advance your career in global maritime operations.
          </p>

          <form ref={form} onSubmit={sendEmail} className="career-form">
            <input type="hidden" name="applied_position" value={formattedPosition} />
            <input type="hidden" name="subject" value={`Job Application: ${formattedPosition}`} />

            <div style={{ marginBottom: "1.25rem" }}>
              <label style={{ display: "block", fontWeight: "600", marginBottom: "0.4rem", color: "#1e293b" }}>Full Name</label>
              <input type="text" name="name" required placeholder="Captain / Engineer / Name" style={{ width: "100%", padding: "0.75rem", borderRadius: "8px", border: "1px solid #cbd5e1" }} />
            </div>

            <div style={{ marginBottom: "1.25rem" }}>
              <label style={{ display: "block", fontWeight: "600", marginBottom: "0.4rem", color: "#1e293b" }}>Email Address</label>
              <input type="email" name="email" required placeholder="your.email@example.com" style={{ width: "100%", padding: "0.75rem", borderRadius: "8px", border: "1px solid #cbd5e1" }} />
            </div>

            <div style={{ marginBottom: "1.25rem" }}>
              <label style={{ display: "block", fontWeight: "600", marginBottom: "0.4rem", color: "#1e293b" }}>Contact Phone / WhatsApp</label>
              <input type="tel" name="phone" placeholder="+94 7X XXX XXXX" style={{ width: "100%", padding: "0.75rem", borderRadius: "8px", border: "1px solid #cbd5e1" }} />
            </div>

            <div style={{ marginBottom: "1.25rem" }}>
              <label style={{ display: "block", fontWeight: "600", marginBottom: "0.4rem", color: "#1e293b" }}>Cover Note & Key Certifications</label>
              <textarea name="message" rows="4" placeholder="Briefly describe your sea-time experience, CDC / STCW certifications, or shore experience." required style={{ width: "100%", padding: "0.75rem", borderRadius: "8px", border: "1px solid #cbd5e1" }}></textarea>
            </div>

            <div style={{ marginBottom: "1.75rem" }}>
              <label style={{ display: "block", fontWeight: "600", marginBottom: "0.4rem", color: "#1e293b" }}>Upload Resume / CV (PDF or DOC)</label>
              <input
                type="file"
                name="resume"
                accept=".pdf,.doc,.docx"
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    const file = e.target.files[0];
                    if (file.size > 5 * 1024 * 1024) {
                      alert("File size exceeds 5MB limit. Please choose a smaller file.");
                      e.target.value = "";
                      setResumeName("");
                    } else {
                      setResumeName(file.name);
                    }
                  }
                }}
                style={{ width: "100%", padding: "0.5rem" }}
              />
              {resumeName && <p style={{ fontSize: "0.85rem", color: "#10b981", marginTop: "0.3rem" }}>Selected: {resumeName}</p>}
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                width: "100%",
                padding: "0.9rem",
                background: isSubmitting ? "#94a3b8" : "linear-gradient(135deg, #0b1d2b, #1a2b49)",
                color: "#ffffff",
                fontWeight: "700",
                fontSize: "1rem",
                borderRadius: "10px",
                border: "none",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                transition: "background 0.3s"
              }}
            >
              {isSubmitting ? "Submitting Application..." : "Submit Application"}
            </button>

            {status && (
              <p
                className="status-message"
                style={{
                  marginTop: "1.25rem",
                  padding: "0.85rem",
                  borderRadius: "8px",
                  background: status.includes("successfully") ? "#ecfdf5" : "#fef2f2",
                  color: status.includes("successfully") ? "#065f46" : "#991b1b",
                  border: `1px solid ${status.includes("successfully") ? "#a7f3d0" : "#fecaca"}`,
                  fontSize: "0.92rem",
                  textAlign: "center"
                }}
              >
                {status}
              </p>
            )}
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Apply;
